import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Product, ProductGroup } from 'src/app/classes';
import { BackEndService } from 'src/app/backend-service';

@Component({
  selector: 'app-product-tree',
  templateUrl: './product-tree.component.html',
  styleUrls: ['./product-tree.component.css']
})
export class ProductTreeComponent implements OnInit {

  @Input() products: Product[];
  @Output() onProductSelect = new EventEmitter();

  productGroups: ProductGroup[] = [];
  productGroupsToggled = {};
  productsToggled = {};

  constructor(
    public backEndService: BackEndService
  ) { }

  getSuborderedGroups(group: ProductGroup): ProductGroup[]{
    if(this.productGroups.length == 0) return [];
    if(group == null) return this.productGroups.filter(x => x.productgroupparent == null);
    else return this.productGroups.filter(x => x.productgroupparent == group.productgroupid);
  }

  getSuborderedProducts(group: ProductGroup): Product[] {
    if(group) return this.products.filter(x => x.productgroup == group.productgroupid);
    return [];
  }

  groupHasProducts(group: ProductGroup): boolean {
    return this.products.filter(x => x.productgroup == group.productgroupid).length > 0;
  }

  groupsProducts(group: ProductGroup): Product[] {
    return this.products.filter(x => x.productgroup == group.productgroupid);
  }

  hasVisibleChild(group: ProductGroup): boolean {
    var subGroups: ProductGroup[] = [];
    this.subGroupsRecursively(group, subGroups);
    return this.oneIsVisibile(subGroups);
  }

  ngOnInit() {
    this.backEndService.get(ProductGroup.url).subscribe((groups: ProductGroup[]) => {
      this.productGroups = groups;
      for(let group of groups){
        this.productsToggled[group.productgroupid.toString()] = false;
        if(group.productgroupparent == null){
          group.deepth = 0;
          this.productGroupsToggled[group.productgroupid.toString()] = true;
        }
        else {
          this.productGroupsToggled[group.productgroupid.toString()] = false;
          let found = false;
          var deepth = 1;
          var currentGroup = group;
          while(!found){
            let parent = this.productGroups.find(x => x.productgroupid == currentGroup.productgroupparent);
            if(parent.deepth != null) {
              deepth += parent.deepth;
              found = true;
            } else {
              currentGroup = parent;
              deepth++;
            }
          }
          group.deepth = deepth;
        }
      }
    });
  }

  oneIsVisibile(groups: ProductGroup[]): boolean {
    for(let group of groups) if(this.productGroupsToggled[group.productgroupid.toString()]) return true;
    return false;
  }

  selectProduct(product: Product){
    this.onProductSelect.emit(product);
  }

  subGroups(group: ProductGroup): ProductGroup[] {
    if(group == null) return [];
    return this.productGroups.filter(x => x.productgroupparent == group.productgroupid);
  }

  subGroupsRecursively(start: ProductGroup, result: ProductGroup[]){
    if(start == null || start.productgroupid == null) return;
    let subGroups = this.subGroups(start);
    for(let group of subGroups){
      if(!result.includes(group)) {
        result.push(group);
        this.subGroupsRecursively(group, result);
      }
    }
  }

  toggleSuborderedGroups(group: ProductGroup){
    var subGroups: ProductGroup[] = [];
    this.subGroupsRecursively(group, subGroups);
    if(this.productsToggled[group.productgroupid.toString()] || this.oneIsVisibile(subGroups)){
      for(let subGroup of subGroups){
        this.productGroupsToggled[subGroup.productgroupid.toString()] = false;
        this.productsToggled[subGroup.productgroupid.toString()] = true;
      }
      this.productsToggled[group.productgroupid.toString()] = false;
    } else {
      let childs = this.subGroups(group);
      for(let subGroup of childs) this.productGroupsToggled[subGroup.productgroupid.toString()] = true;
      this.productsToggled[group.productgroupid.toString()] = true;
    }
  }

}
